import { sourcesDestinationsConstants } from "../_constants";

export function sourcesDestinationsByConnectionId(state = {}, action) {
  switch (action.type) {
    case sourcesDestinationsConstants.GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_REQUEST:
      return {
        loading: true,
      };
    case sourcesDestinationsConstants.GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_SUCCESS:
      return {
        item: action.data,
      };
    case sourcesDestinationsConstants.GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
export function sourcesDestinationsEditById(state = {}, action) {
  switch (action.type) {
    case sourcesDestinationsConstants.EDIT_SOURCE_AND_DESTINATION_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case sourcesDestinationsConstants.EDIT_SOURCE_AND_DESTINATION_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case sourcesDestinationsConstants.EDIT_SOURCE_AND_DESTINATION_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function sourcesDestinationsDeleteById(state = {}, action) {
  switch (action.type) {
    case sourcesDestinationsConstants.DELETE_SOURCE_AND_DESTINATION_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case sourcesDestinationsConstants.DELETE_SOURCE_AND_DESTINATION_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case sourcesDestinationsConstants.DELETE_SOURCE_AND_DESTINATION_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}






